import { useCallback, useSyncExternalStore } from 'react'
import { isEqual as deepEqual } from 'lodash'
import { BehaviorSubject, distinctUntilChanged } from 'rxjs'

export function useBehaviorSubject<T>(value$: BehaviorSubject<T>) {
    return useSyncExternalStore(
        useCallback(
            (onChange) => {
                const sub = value$.pipe(distinctUntilChanged(deepEqual)).subscribe(onChange)
                return () => sub.unsubscribe()
            },
            [value$]
        ),
        useCallback(() => value$.value, [value$])
    )
}
